import { submitPasswordRequest } from 'actions/authentication';
import FormSubmitButton from 'components/FormElements/FormSubmitButton';
import FormTextField from 'components/FormElements/FormTextField';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { Required } from 'utils/validators';
import './index.scss';

class ResetForm extends Component {
  submitPasswordRequest = () => {
    const { email } = this.props.formValues;
    this.props.submitPasswordRequest(email);
  };

  render() {
    return (
      <div>
        <form>
          <Field
            name="email"
            type="email"
            margin="normal"
            placeholder="john.smith@me.com"
            fullWidth
            component={FormTextField}
            validate={[Required]}
            label="Email Address"
          />
          <FormSubmitButton
            disabled={this.props.resetLinkSent}
            onClick={this.submitPasswordRequest}
            className="reset__submit"
            loading={this.props.loading}
          >
            {this.props.resetLinkSent ? 'Link Sent' : 'Request Reset'}
          </FormSubmitButton>
        </form>

        <div className="reset__error" role="alert">
          {this.props.resetError.detail}
        </div>
        <div className="reset__success" role="alert">
          {this.props.resetLinkSent
            ? 'We have sent you a link. Please check your mailbox.'
            : ''}
        </div>

        <Link to="./login" className="return__login__link">
          Return to Login
        </Link>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues('reset')(state) || {},
    loading: state.authentication.loading,
    resetError: state.authentication.resetError,
    resetLinkSent: state.authentication.resetLinkSent,
  };
};

const mapDispatchToProps = dispatch => ({
  submitPasswordRequest: email => dispatch(submitPasswordRequest(email)),
});

const component = connect(mapStateToProps, mapDispatchToProps)(ResetForm);

export default reduxForm({
  form: 'reset',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(component);



// WEBPACK FOOTER //
// ./src/components/Authentication/ResetForm/index.jsx